import type { FC } from 'react';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Loader } from '@/components/Loader';
import { ServerErrors } from '@/components/ServerErrors';
import type { ApiErrorWithType } from '@/lib/types';

import { ShoppingBagHeaderDesktop } from '../ShoppingBagHeaderDesktop';
import { ShoppingBagHeaderMobile } from '../ShoppingBagHeaderMobile';
import { EmptyShoppingBagContent } from './EmptyShoppingBagContent';

import * as S from './EmptyShoppingBag.styles';

interface EmptyShoppingBagProps {
  errors?: ApiErrorWithType[];
  isInitializing?: boolean;
}

export const EmptyShoppingBag: FC<EmptyShoppingBagProps> = ({
  errors = [],
  isInitializing = false,
}) => {
  return (
    <Box data-test-id='EmptyShoppingBag'>
      <ShoppingBagHeaderMobile data-test-id='EmptyShoppingBagShoppingBagHeaderMobile' />
      <ShoppingBagHeaderDesktop data-test-id='EmptyShoppingBagShoppingBagHeaderDesktop' />
      <Container>
        <ServerErrors errors={errors}></ServerErrors>
        <S.Body>
          {isInitializing ? (
            <Loader data-test-id='ShoppingBagViewLoader' />
          ) : (
            <EmptyShoppingBagContent />
          )}
        </S.Body>
      </Container>
    </Box>
  );
};

export default EmptyShoppingBag;
